module.exports = __webpack_public_path__ + "img/water.35da8943.png";